import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { FormGroup, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DateObject } from "react-multi-date-picker";
import { convertToGregorian } from "../../../../utils/date";
import { LocaleContext } from "../../../../routing/LangRouter";

//import general components
import BasePopover from "../../../common/base-popover/base-popover";
import { BaseButton } from "../../../common/base-button/base-button";
import SingleDatePicker from "../../../common/single-date-picker/single-date-picker";
import BaseCheckbox from "../../../common/base-checkbox/base-checkbox";

//import images and icons
import { ArrowDown2, ArrowUp2 } from "iconsax-react";
import ArrowIcon from "../../../common/arrow-icon/arrow-icon";

//import styles
import "../../../common/base-filter/base-filter.scss";

function OrderFilter({ submit }) {
    //general variables
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();
    const { control } = useForm();

    //handle drop down
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    //status filter
    const [statusFilter, setStatusFilter] = useState({ paymentSuccess: false, cancelled: false, preReserve: false });
    const handleCheckBoxChange = event => {
        const { name, checked } = event.target;
        setStatusFilter(values => ({ ...values, [name]: checked }));
    };

    //date filter
    //handle date change
    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState();
    const handleFromDateChange = dateValue => {
        if (dateValue) setFromDate(dateValue);
    };
    const handleToDateChange = dateValue => {
        if (dateValue) setToDate(dateValue);
    };

    //convert date
    const [optimizedFromDate, setOptimizedFromDate] = useState();
    const [optimizedToDate, setOptimizedToDate] = useState();
    useEffect(() => {
        if (fromDate) {
            const convertedFromDate = convertToGregorian(fromDate);
            setOptimizedFromDate(convertedFromDate?.toISOString().split("T")[0]);
        }
        if (toDate) {
            const convertedToDate = convertToGregorian(toDate);
            setOptimizedToDate(convertedToDate?.toISOString().split("T")[0]);
        }
    }, [fromDate, toDate]);

    //default value date
    const [defaultValueFromDate, setDefaultValueFromDate] = useState();
    const [defaultValueToDate, setDefaultValueToDate] = useState();
    useEffect(() => {
        if (!!fromDate) setDefaultValueFromDate(new DateObject(new Date(fromDate)));
        if (!!toDate) setDefaultValueToDate(new DateObject(new Date(toDate)));
    }, [anchorEl]);

    //filter submit
    const filterSubmit = () => {
        handleClose();
        submit(statusFilter, optimizedFromDate, optimizedToDate);
    };

    //reset filter
    const resetFilter = () => {
        setFromDate();
        setDefaultValueFromDate();

        setToDate();
        setDefaultValueToDate();

        setStatusFilter({ paymentSuccess: false, cancelled: false, preReserve: false });

        submit(null, null, null);
    };

    const filterList = [
        { id: 1, name: "paymentSuccess", label: "پرداخت شده" },
        { id: 2, name: "cancelled", label: "لغو شده" },
        { id: 3, name: "preReserve", label: "پیش رزرو" },
    ];

    return (
        <Grid className="base-filter" container item xs={2.5}>
            <Grid
                className="base-filter__title order"
                container
                item
                xs={12}
                justifyContent="space-between"
                alignItems="center"
                onClick={handleClick}
            >
                <Grid
                    component="span"
                    container
                    item
                    xs="auto"
                    onClick={event => {
                        event.stopPropagation();
                    }}
                >
                    {t("filter")}
                </Grid>
                <Grid
                    className="base-filter__cancel-filter order"
                    component="span"
                    container
                    item
                    xs="auto"
                    onClick={event => {
                        event.stopPropagation();
                        resetFilter();
                    }}
                >
                    {t("cancelFilter")}
                </Grid>
                <Grid container item xs="auto" display={{ xs: "none", md: "flex" }}>
                    <ArrowIcon icons={[ArrowDown2, ArrowUp2]} isExpanded={open} size="24" color="var(--light-color)" />
                </Grid>
            </Grid>

            <BasePopover id={id} open={open} anchorEl={anchorEl} handleClose={handleClose} width="12.8%" vertical="bottom" horizontal="right">
                <Grid container item xs={12} rowGap={2}>
                    <Grid container item xs={12}>
                        <FormGroup className="base-filter__filter-label">
                            {filterList.map(filter => {
                                return (
                                    <BaseCheckbox
                                        key={filter?.id}
                                        label={filter.label}
                                        name={filter.name}
                                        checked={statusFilter?.[filter.name]}
                                        handleChange={handleCheckBoxChange}
                                    />
                                );
                            })}
                        </FormGroup>
                    </Grid>

                    <Grid container item xs={12} rowGap={2} mt={3}>
                        <Grid className="base-filter__filter-title" container item xs={12}>
                            بازه زمانی
                        </Grid>
                        <Grid container item xs={12} justifyContent="space-between" alignItems="center">
                            <Grid className="base-filter__date-title" component="span" container item xs="auto">
                                از تاریخ:
                            </Grid>
                            <Grid container item xs={8}>
                                <SingleDatePicker
                                    size="small"
                                    name="startDate"
                                    control={control}
                                    handleChange={handleFromDateChange}
                                    defaultValue={defaultValueFromDate}
                                    isPersianCalendar={locale === "fa"}
                                />
                            </Grid>
                        </Grid>
                        <Grid container item xs={12} justifyContent="space-between" alignItems="center">
                            <Grid className="base-filter__date-title" component="span" container item xs="auto">
                                تا تاریخ:
                            </Grid>
                            <Grid container item xs={8}>
                                <SingleDatePicker
                                    size="small"
                                    name="startEnd"
                                    control={control}
                                    handleChange={handleToDateChange}
                                    defaultValue={defaultValueToDate}
                                    isPersianCalendar={locale === "fa"}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <BaseButton text="اعمال فیلتر" color="primary" radius="radius-10" size="medium" handleClick={filterSubmit} />
                </Grid>
            </BasePopover>
        </Grid>
    );
}

export default OrderFilter;
